export default __webpack_public_path__ + "static/media/screen.69bc6e95.png";